import React from "react";
import '../../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import Breadcrumbs from '../../../Components/Common/Breadcrumb';
import "flatpickr/dist/themes/material_green.css";
import Detail from "./Detail";

const MrPersonEntity = () => {

  document.title = "Хэрэглэгчийн удирдлага";

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Үндсэн бүртгэл" breadcrumbItem="Хэрэглэгчийн удирдлага" />
          <Detail />
        </div>
      </div>
    </React.Fragment>
  );
}


export default MrPersonEntity;